'use client';

import { useEffect, useState } from 'react';
import { Toaster } from 'sonner';

export function ResponsiveToaster() {
  const [position, setPosition] = useState<'top-center' | 'bottom-right'>('bottom-right');

  useEffect(() => {
    const updatePosition = () => {
      setPosition(window.innerWidth < 768 ? 'top-center' : 'bottom-right');
    };

    updatePosition();
    window.addEventListener('resize', updatePosition);
    return () => window.removeEventListener('resize', updatePosition);
  }, []);

  return (
    <Toaster
      position={position}
      expand={false}
      closeButton
      toastOptions={{
        className: 'font-sans',
        classNames: {
          toast: 'group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border-border rounded-md',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-foreground group-[.toast]:text-card group-[.toast]:hover:bg-foreground/90',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:hover:bg-muted/80',
        },
      }}
      offset={20}
      gap={8}
      duration={4000}
    />
  );
}
